module.exports = __webpack_public_path__ + "static/img/poster.a8c2d407.jpg";